import Icon from "./Icon";

export default function Button({type = "btn-default", url, text = "Videre", icon = false}) {
    return (
        <a className={`btn ${type}`} href={url}>
            {text} 
            {icon ? <Icon icon={icon} /> : null}
        </a>
    )
}